import TransparentButton from '@/trio-ui/TransparentButton';
import { InterviewReviewType, InterviewType } from '@/types/api';
import { InterviewTypes } from '@/utils/interviews';
import * as Styles from './InterviewReviewsManager.styles';
import FinalScore from '../FinalScore';
import InterviewReview from '../InterviewReview';

export type CustomReviewType = Partial<
  InterviewReviewType & {
    isEditing: boolean;
  }
>;

type InterviewReviewsManagerComponentProps = Pick<InterviewType, 'reviewsResult' | 'finalScore'> & {
  reviews: CustomReviewType[];
  canAddNewReview: boolean;
  isActionLoading: boolean;
  emptyMessage: string;
  interviewType: InterviewTypes;
  onAddNewReview: (event: any) => void;
  onCancelAddNewInterviewReview: (interviewReviewIndex: number) => void;
  onAddNewInterviewReview: (index: number, newReview: CustomReviewType) => Promise<boolean>;
  onGenerateReviewWithAI: (index: number, newReview: CustomReviewType) => Promise<boolean>;
  onDeleteInterviewReview: (interviewReviewId: string) => Promise<boolean>;
};

export default function InterviewReviewsManagerComponent({
  canAddNewReview,
  isActionLoading,
  reviews,
  reviewsResult,
  finalScore,
  emptyMessage,
  interviewType,
  onAddNewInterviewReview,
  onAddNewReview,
  onGenerateReviewWithAI,
  onDeleteInterviewReview,
  onCancelAddNewInterviewReview,
}: InterviewReviewsManagerComponentProps): JSX.Element {
  return (
    <div>
      <Styles.Title>Reviews</Styles.Title>

      {canAddNewReview ? (
        <>
          {reviews?.map((review, index) => {
            if (review.score?.length) {
              return (
                <InterviewReview
                  isActionLoading={isActionLoading}
                  key={review.id || `review-${index}`}
                  inputList={review.score}
                  onDelete={onDeleteInterviewReview}
                  onSave={onAddNewInterviewReview}
                  onGenerateReviewWithAI={onGenerateReviewWithAI}
                  onCancel={onCancelAddNewInterviewReview}
                  index={index}
                  id={review.id}
                  note={review.note}
                  reviewer={review.user}
                  reviewedAt={review.updatedAt}
                  interviewType={interviewType}
                />
              );
            }

            return null;
          })}

          <TransparentButton onClick={onAddNewReview} isBlueButton>
            + New Review
          </TransparentButton>

          {!!finalScore && <FinalScore resultLabel={reviewsResult} scoreLabel={finalScore} />}
        </>
      ) : (
        <Styles.EmptyMessage>{emptyMessage}</Styles.EmptyMessage>
      )}
    </div>
  );
}
